<rt-heading variant="heading large-xx light" margin-bottom>{{ data.heading }}</rt-heading>
<div [class]="'gradient gradient--' + data.topCard.color"></div>
<rt-box class="no-radius-top">
  <div class="heading-content">
    <rt-heading variant="heading large-x">{{ data.topCard.heading }}</rt-heading>
    @if (data.topCard.subheading) {
      <p [innerHTML]="data.topCard.subheading"></p>
    }
  </div>
  <div class="row">
    @for (topCol of data.topCard.featuresTop; track trackByIndex) {
      <div class="column">
        @for (feature of topCol; track trackByLabel) {
          <rt-feature-item
            [label]="feature.label"
            [tooltip]="feature.tooltip"
            [icon]="feature.altIcon"
            [isBold]="feature.isBold"
          />
        }
      </div>
    }
  </div>
  @if (data.topCard.infobox || data.topCard.featuresBottom || data.topCard.ytVideoId) {
    <rt-divider />
  }
  @if (data.topCard.featuresBottom) {
    <div class="row">
      @for (bottomCol of data.topCard.featuresBottom; track trackByIndex) {
        <div class="column">
          @for (feature of bottomCol; track trackByLabel) {
            <rt-feature-item
              [label]="feature.label"
              [tooltip]="feature.tooltip"
              [icon]="feature.altIcon"
              [isBold]="feature.isBold"
            />
          }
        </div>
      }
    </div>
  }
  @if (videoUrl) {
    <iframe
      [src]="videoUrl"
      [style.background]="'transparent'"
      type="text/html"
      width="100%"
      height="360"
      allowFullScreen
      mozallowfullscreen
      webkitAllowFullScreen
    >
    </iframe>
  }
  @if (data.topCard.infobox) {
    <rt-infobox [iconName]="'bulb'" [isDismissible]="false">
      <span [innerHTML]="data.topCard.infobox"></span>
    </rt-infobox>
  }
</rt-box>
@if (data.bottomCard) {
  <rt-box>
    <div class="heading-content">
      <rt-heading variant="heading large-x">{{ data.bottomCard.heading }}</rt-heading>
    </div>
    @for (feature of data.bottomCard.features; track trackByLabel) {
      <rt-feature-item
        [label]="feature.label"
        [tooltip]="feature.tooltip"
        [icon]="feature.altIcon"
        [isBold]="feature.isBold"
      />
    }
    @if (data.bottomCard.infobox) {
      <rt-infobox [iconName]="'bulb'" [isDismissible]="false">
        <span [innerHTML]="data.bottomCard.infobox"></span>
      </rt-infobox>
    }
  </rt-box>
}
<div class="footer">
  <rt-button (click)="back()" variant="plain">{{
    'app.pricing.plan_picker_2024.migration.view_plans' | translate
  }}</rt-button>
  @switch (data.continueVariant) {
    @case ('primary') {
      <rt-button (click)="continue()" variant="primary"
        >{{ data.continueLabel }}<rt-icon suffix name="chevron-right"
      /></rt-button>
    }
    @case ('danger') {
      <rt-button (click)="continue()" variant="error"
        >{{ data.continueLabel }}<rt-icon suffix name="chevron-right"
      /></rt-button>
    }
  }
</div>
